import isEmpty from 'lodash/isEmpty';
import isUndefined from 'lodash/isUndefined';
import {window} from 'ssr-window';
import Config from 'config';
import BranchUtils from 'utils/branch';

const AppStoreUtils = {
    appStoreLinkClicked({device, channel, email}) {
        if (isEmpty(channel)) {
            throw new Error('Channel attribute is required.');
        }

        if (!Config.isMobile && isEmpty(device)) {
            throw new Error(
                'Device attribute is required for desktop browsers.'
            );
        }

        // desktop leverages short links generated by the product team
        // mobile uses the branch sdk to generate links
        if (!Config.isMobile) {
            switch (device) {
                case 'ios':
                    switch (channel) {
                        case 'prepurchase':
                            window.open(
                                'https://bnc.lt/Eujc/TzuillX1Rs',
                                '_blank'
                            );
                            break;

                        case 'postpurchase':
                            window.open(
                                'https://bnc.lt/Eujc/ddIi7wY1Rs',
                                '_blank'
                            );
                            break;
                    }

                    break;

                case 'android':
                    switch (channel) {
                        case 'prepurchase':
                            window.open(
                                'https://bnc.lt/Eujc/TsP3lj21Rs',
                                '_blank'
                            );
                            break;

                        case 'postpurchase':
                            window.open(
                                'https://bnc.lt/Eujc/dpblUp51Rs',
                                '_blank'
                            );
                            break;
                    }

                    break;
            }

            return false;
        }

        const data = {
            channel,
        };

        if (!isUndefined(email)) {
            data.email = email;
        }

        BranchUtils.link(
            {
                data,
            },
            (err, link) => {
                if (!err) {
                    window.location = link;
                }
            }
        );
    },
};

export default AppStoreUtils;
